import React, { Component } from "react";
import NumberFormat from "react-number-format";

class SummaryBox extends Component {
	render() {
		return (
			<div className="dashboard_summary_box">
				<div className="value">
					<NumberFormat value={this.props.value} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={"$"} />
				</div>
				<div className="title">{this.props.title}</div>
			</div>
		);
	}
}

export default SummaryBox;



// WEBPACK FOOTER //
// ./src/components/admin/dashboard/SummaryBox.js